import { useState, useEffect, useRef } from "react"
import { CSvgArrowRight, CSvgCalender, CSvgReport, CSvgClock, CSvgHelp, CSvgReplay } from '../../components/CSvg'
import { Link, useNavigate } from "react-router-dom";
import { ContextNav } from "../../context";
import { NavBar, DrowerBottom, ModalFilterDate, SkeletonRollCall, BtnLoader, Pagination } from "../../components";
import { handelGetListVacationMethod, handelAddVacationMethod, handelGetVacationReasonList } from '../../methods'
import { ConverDurationToMin, ConvertMiladiDateToJalili, GetToDay, StartCurrentMonth } from "../../utils";
import DatePicker from "react-multi-date-picker";
import persian from "react-date-object/calendars/persian"
import persian_fa from "react-date-object/locales/persian_fa"
import { ConvertStringDateToNumberDate } from "../../utils";


export const Vacation = () => {
    const formRef: any = useRef()
    const [activeItem, setActiveItem] = useState<number>(-1)
    const [displaySkeleton, setDisplaySkeleton] = useState<boolean>(false)
    const [displayBtn, setDisplayBtn] = useState<boolean>(false)
    const [visibleFilter, setVisibleFilter] = useState<boolean>(false)
    const [visibleAdd, setVisibleAdd] = useState<boolean>(false)
    const [vacationTab, setVacationTab] = useState<number>(1)
    const [vacationList, setVacationList] = useState<any>(null)
    const [visibleDate, setVisibleDate] = useState<boolean>(false)
    const [dateFilter, setDateFilter] = useState<any>(null)
    const [dateForAdd, setDateForAdd] = useState<any>(null)
    const [filterStatus, setFilterStatus] = useState<number>(-1)
    const [vacationReason, setVacationReason] = useState<any>([])
    const [pagination, setPagination] = useState({
        'current': 1,
        'total': 1,
    })

    const handelAddVacation = async (e: any) => {
        e.preventDefault()
        await handelAddVacationMethod(formRef, dateForAdd, vacationTab, setDisplayBtn, setVisibleAdd, setDateForAdd)
        await handelGetListVacationMethod(dateFilter?.start_jalali, dateFilter?.end_jalali, setVacationList, setDisplaySkeleton, filterStatus, pagination, setPagination)
    }

    const findeInVacationReason = (id: any) => {
        for (let i of vacationReason) {
            if (i.id == id) {
                return i.title
            }
        }
    }

    const handelChangeDate = (e: any, type: string) => {
        let data = { ...dateForAdd };
        data[type] = new Date(e?.toDate?.().toString())
        data[`${type}_jalali`] = ConvertStringDateToNumberDate(e?.toDate?.().toString())
        setDateForAdd(data)
    }

    const handelFilterStatus = (id: number) => {
        setFilterStatus(id)
        handelGetListVacationMethod(dateFilter?.start_jalali, dateFilter?.end_jalali, setVacationList, setDisplaySkeleton, id, pagination, setPagination)
        setVisibleFilter(false)
    }

    const handelFilterDate = () => {
        handelGetListVacationMethod(dateFilter?.start_jalali, dateFilter?.end_jalali, setVacationList, setDisplaySkeleton, filterStatus, pagination, setPagination)
    }

    useEffect(() => {
        handelGetVacationReasonList(setVacationReason)
    }, [])

    useEffect(() => {
        document.title = "مرخصی | دایان"
        if (pagination.current) {
            handelGetListVacationMethod(dateFilter?.start_jalali, dateFilter?.end_jalali, setVacationList, setDisplaySkeleton, filterStatus, pagination, setPagination)
        }
    }, [pagination?.current])

    return (
        <>
            <div className='w-full min-h-screen flex flex-col'>
                <NavBar
                    title='مرخصی'
                    isAdd={true}
                    isCalender={true}
                    isFilter={true}
                    onClickFilter={() => { setVisibleFilter(true) }}
                    onClickAdd={() => { setVisibleAdd(true) }}
                    onClickCalender={() => { setVisibleDate(true) }}
                />
                <div className='w-full flex flex-col p-[20px]'>
                    <div className='w-full flex flex-col overflow-hidden '>
                        {displaySkeleton == false && vacationList?.data?.map((item: any, index: number) =>
                            <div onClick={() => { setActiveItem(index) }} className='w-full cursor-pointer  flex justify-end bg-[#f9f9f9] shadow rounded-md mt-3 text-sm overflow-hidden relative'>
                                <div className={`w-[35px] absolute top-0 bottom-0 right-0  flex items-center justify-center ${item.status == 0 && 'bg-orange-400'} ${item.status == 2 && 'bg-[tomato]'} ${item.status == 1 && 'bg-green-400'} `}>
                                    <div className=' text-sm text-white rotate-90 text-center '>
                                        <div className='w-[100px]'>
                                            {item.status == 0 && 'در حال بررسی '}
                                            {item.status == 1 && 'موجه '}
                                            {item.status == 2 && 'غیرموجه'}
                                        </div>
                                    </div>
                                </div>
                                <div className='w-[calc(100%-35px)]  px-[10px] flex flex-col'>
                                    <div className='w-full h-[40px]  border-b border-dashed border-gray-400 flex items-center justify-between'>
                                        <span className=''>{item.type == 1 ? "مرخصی ساعتی" : 'مرخصی روزانه'}</span>
                                        <CSvgArrowRight className={`w-[15px] transition-all fill-gray-800 ${activeItem == index ? 'rotate-90' : 'rotate-180'}`} />
                                    </div>
                                    <div className={`w-full pb-[15px] text-[13px] transition-all`}>
                                        <div className='w-full flex items-center mt-[15px]'>
                                            <CSvgHelp className="fill-gray-500 w-[20px] " />
                                            <span className='text-gray-500 mx-1 '>علت :</span>
                                            <span>{findeInVacationReason(item?.vacation_reason_id)}</span>
                                        </div>
                                        <div className='w-full flex items-center mt-[15px]'>
                                            <CSvgCalender className="fill-gray-500 w-[20px]  " />
                                            <span className='text-gray-500 mx-1 '>تاریخ ایجاد :</span>
                                            <span>{ConvertMiladiDateToJalili(item?.created_at.slice(0, 10))}</span>
                                        </div>
                                        <div className={`w-full flex flex-col transition-all overflow-hidden ${activeItem == index ? 'max-h-[auto]' : 'max-h-0 '}`}>
                                            <div className='w-full flex items-center mt-[15px]'>
                                                <CSvgCalender className="fill-gray-500 w-[20px]  " />
                                                <span className='text-gray-500 mx-1 '>{item.type == 1 ? 'تاریخ مرخصی' : 'تاریخ شروع مرخصی'} :</span>
                                                <span className=''>{ConvertMiladiDateToJalili(item?.date_from.slice(0, 10))}</span>
                                            </div>
                                            {item.type == 1 &&
                                                <div className='w-full flex items-center mt-[15px]'>
                                                    <CSvgClock className="fill-gray-500 w-[20px]  " />
                                                    <span className='text-gray-500 mx-1 '>ساعت مرخصی :</span>
                                                    <span className=''>{item?.date_from.slice(11, 16)} تا {item?.date_to.slice(11, 16)}</span>
                                                </div>
                                            }
                                            {item.type == 2 &&
                                                <div className='w-full flex items-center mt-[15px]'>
                                                    <CSvgCalender className="fill-gray-500 w-[20px]  " />
                                                    <span className='text-gray-500 mx-1 '>تاریخ پایان مرخصی :</span>
                                                    <span className=''>{ConvertMiladiDateToJalili(item?.date_to.slice(0, 10))}</span>
                                                </div>
                                            }
                                            <div className='w-full flex items-center mt-[15px]'>
                                                <CSvgReport className="fill-gray-500 w-[20px]  " />
                                                <span className='text-gray-500 mx-1 '> توضیح :</span>
                                                <span className=''>{item?.description}</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}
                        {displaySkeleton == false && vacationList?.data?.length == 0 &&
                            <div className="w-full h-[200px] flex justify-center items-center text-gray-400">
                                <span>موردی یافت نشد !</span>
                            </div>
                        }
                        {displaySkeleton && <SkeletonRollCall />}
                        <Pagination pagination={pagination} setPagination={setPagination} loading={displaySkeleton} />
                    </div>
                </div>
            </div>

            <DrowerBottom visible={visibleFilter} setVisible={setVisibleFilter} >
                <div className='w-full flex flex-col justify-center items-center pt-[20px]'>
                    <button onClick={() => handelFilterStatus(-1)} className='w-full h-[40px] rounded border border-dayan-orange-50  my-2'>همه</button>
                    <button onClick={() => handelFilterStatus(0)} className='w-full h-[40px] rounded border border-dayan-orange-50 my-2'>در دست بررسی</button>
                    <button onClick={() => handelFilterStatus(1)} className='w-full h-[40px] rounded border border-dayan-orange-50  my-2'>تایید شده</button>
                    <button onClick={() => handelFilterStatus(2)} className='w-full h-[40px] rounded border border-dayan-orange-50  my-2'>رد شده</button>
                </div>
            </DrowerBottom>

            <DrowerBottom visible={visibleAdd} setVisible={setVisibleAdd} >
                <form id="form-add-vacation" onSubmit={handelAddVacation} ref={formRef} className='w-full min-h-[600px] flex flex-col  items-center py-[20px]'>
                    <div className='w-full flex items-center rounded-md overflow-hidden border border-dayan-orange-50 cursor-pointer'>
                        <div onClick={() => { setVacationTab(1) }} className={`w-full h-[40px] flex items-center justify-center rounded-md text-sm ${vacationTab == 1 ? 'bg-dayan-orange-50 text-white' : 'text-dayan-orange-50'} `}>ساعتی</div>
                        <div onClick={() => { setVacationTab(2) }} className={`w-full h-[40px] flex items-center justify-center rounded-md text-sm ${vacationTab == 2 ? 'bg-dayan-orange-50 text-white' : 'text-dayan-orange-50'} `}>روزانه</div>
                    </div>
                    {vacationTab == 2 &&
                        <div className="filteDate w-full flex flex-col mt-4">
                            <span className="text-xs text-gray-500 mb-2">تاریخ شروع مرخصی</span>
                            <DatePicker className="" calendar={persian} locale={persian_fa} value={dateForAdd?.startDate} onChange={(e: any) => handelChangeDate(e, 'startDate')} />
                        </div>
                    }
                    {vacationTab == 2 &&
                        <div className="filteDate w-full flex flex-col mt-4">
                            <span className="text-xs text-gray-500 mb-2">تاریخ پایان مرخصی</span>
                            <DatePicker className="" calendar={persian} locale={persian_fa} value={dateForAdd?.endDate} onChange={(e: any) => handelChangeDate(e, 'endDate')} />
                        </div>
                    }
                    {vacationTab == 1 &&
                        <div className="filteDate w-full flex flex-col mt-4">
                            <span className="text-xs text-gray-500 mb-2">تاریخ مرخصی</span>
                            <DatePicker className="" calendar={persian} locale={persian_fa} value={dateForAdd?.oneDate} onChange={(e: any) => handelChangeDate(e, 'oneDate')} />
                        </div>
                    }
                    {vacationTab == 1 &&
                        <div className='w-full flex items-center mt-3'>
                            <div className='w-full pl-2'>
                                <div className=" w-full flex flex-col mt-2">
                                    <span className="text-xs text-gray-500 mb-2">ساعت شروع</span>
                                    <input type='time' name='startTime' placeholder='ساعت شروع' className='w-full h-[40px] border border-gray-400 rounded-md px-2 text-sm  focus:outline-none' required={true} />
                                </div>
                            </div>
                            <div className='w-full pr-2'>
                                <div className=" w-full flex flex-col mt-2">
                                    <span className="text-xs text-gray-500 mb-2">ساعت پایان</span>
                                    <input type='time' name='endTime' placeholder='ساعت شروع' className='w-full h-[40px] border border-gray-400 rounded-md px-2 text-sm  focus:outline-none' required={true} />
                                </div>
                            </div>
                        </div>
                    }
                    <div className=" w-full flex flex-col mt-4">
                        <span className="text-xs text-gray-500 mb-2">دلیل مرخصی</span>
                        <select name='reason' placeholder='انتخاب تاریخ' className='w-full h-[40px]  bg-transparent border border-gray-400 rounded-md px-2 text-sm  focus:outline-none' required={true} >
                            <option value="" disabled selected>انتخاب کنید</option>
                            {vacationReason.map((item: any, index: number) =>
                                <option value={item.id}>{item.title}</option>
                            )}
                        </select>
                    </div>
                    <div className=" w-full flex flex-col mt-4">
                        <span className="text-xs text-gray-500 mb-2">توضیحات</span>
                        <textarea name='description' placeholder='توضیحات' className='w-full min-h-[70px] border border-gray-400 rounded-md p-2 text-sm  focus:outline-none' />
                    </div>
                    {displayBtn ?
                        <button type={'button'} className='w-full h-[40px] bg-dayan-orange-50 text-white text-sm mb-2 mt-6 rounded-md relative flex items-center justify-center'><BtnLoader /></button>
                        :
                        <button type={'submit'} className='w-full h-[40px] bg-dayan-orange-50 text-white text-sm mb-2 mt-6 rounded-md'>ثبت درخواست مرخصی</button>
                    }
                </form>
            </DrowerBottom>

            <ModalFilterDate
                visible={visibleDate}
                setVisible={setVisibleDate}
                dateKeeper={dateFilter}
                setDateKeeper={setDateFilter}
                btnLoader={displayBtn}
                onFinish={handelFilterDate}
            />

        </>
    );
}